<!--中间框架页-->
<template>
    <div style="min-width:1170px">
        <Header ref="head" class="my-header"></Header>
        <div style="position:relative" v-if="show">
            <div class="float-logo-container-right" v-if="jujuimg.length">
                <div v-for="(item,index) in jujuimg" :key="index" @click="toUrl(jujuurl[index])" :style="jujuurl[index]!='#'?'cursor:pointer;padding: 18px 11px 22px 12px;':'padding: 18px 11px 22px 12px;'">
                    <img class="img-style" :style="'width:'+item.imgWidth+'px;height:'+item.imgHeight+'px;'" :src="item.imgUrl" alt="" >
                </div>
            </div>
            <div class="float-logo-container-left"  v-if="ananimg.length">
                <div v-for="(item,index) in ananimg" :key="index" @click="toUrl(ananurl[index])" :style="ananurl[index]!='#'?'cursor:pointer;padding: 18px 11px 22px 12px;':'padding: 18px 11px 22px 12px;'">
                    <img class="img-style" :style="'width:'+item.imgWidth+'px;height:'+item.imgHeight+'px'" :src="item.imgUrl" alt="">
                </div>
            </div>
        </div>
        <keep-alive >
            <router-view  style="min-height: 700px;" />
        </keep-alive>
        <Footer class="my-footer"></Footer>
    </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
import {ieVersion} from '@/helper/device'
import {  get, post } from "@/api/common/index";
export default {
    name: 'index',
    data () {
        return {
            ananimg:[],
            jujuimg:[],
            jujuurl:[],
            ananurl:[],
            show:false
        }
    },
    components: {
        Header,
        Footer
    },
    methods:{
        toUrl(url){
            if(url!='#'){
                let a = document.createElement('a')
                a.setAttribute('target','view_window')
                a.href = url
                a.click()
            }
        },
        getAdvertisement(){
            get('/api/website/get_advertisement_list').then(res => {
                if (res.success) {
                    this.ananimg = []
                    this.ananurl = []
                    this.jujuimg = []
                    this.jujuurl = []
                    for(var i = 0 ;i<res.data.length;i++){
                        if(res.data[i].type==0){
                            if(res.data[i].position==0){
                                var oimg = {
                                    imgUrl:res.data[i].imgUrl,
                                    imgWidth:res.data[i].imgWidth,
                                    imgHeight:res.data[i].imgHeight
                                }
                                this.ananimg.push(oimg)
                                this.ananurl.push(res.data[i].url)
                            }else{
                                var oimg = {
                                    imgUrl:res.data[i].imgUrl,
                                    imgWidth:res.data[i].imgWidth,
                                    imgHeight:res.data[i].imgHeight
                                }
                                this.jujuimg.push(oimg)
                                this.jujuurl.push(res.data[i].url)
                            }
                        }
                    }
                    window.addEventListener('scroll', this.windowScroll)
                    if(this.jujuimg.length||this.ananimg.length){
                        this.windowScroll()
                    }
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        windowScroll() {
                this.show = true
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop>316){
                    var obj = document.getElementsByClassName("float-logo-container-left")[0];
                    if(obj){
                        obj.style.top = '200px'
                        obj.style.position = 'fixed'
                    }
                }else{
                    var obj = document.getElementsByClassName("float-logo-container-left")[0];
                    if(obj){
                        obj.style.position = 'absolute'
                        obj.style.top = '0'
                    }
                }
                if(scrollTop>316){
                    var obj = document.getElementsByClassName("float-logo-container-right")[0];
                    if(obj){
                        obj.style.position = 'fixed'
                        obj.style.top = '200px'
                    }
                }else{
                    var obj = document.getElementsByClassName("float-logo-container-right")[0];
                    if(obj){
                        obj.style.position = 'absolute'
                        obj.style.top = '0'
                    }
                }
        },
        isMobile() {
            if(config.wxUrl){
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                if(flag){
                    let a = document.createElement('a')
                    a.href = config.wxUrl
                    a.click()
                }
                return flag;
            }
        }
    },
    watch: {
        '$route' () {
        }
    },
    created(){
        var version = ieVersion();
        if(version > 0 && version < 10){
            this.$alert('此网站不再支持IE9及以下版本的浏览器，请使用最新的谷歌、IE11或微软Edge浏览器以获得更好的体验，谢谢！', '系统提醒', {
                confirmButtonText: '确定',
                callback: () => {
                    //this.reload();
                }
            });
            this.$notify({
                title: '系统提醒',
                message: '此网站不再支持IE9及以下版本的浏览器，请使用最新的谷歌、IE11或微软Edge浏览器以获得更好的体验，谢谢！',
                duration: 0,
                type: 'warning',
                position: 'bottom-right',
                showClose: false
            });
        }
        document.title = '嘉定住房集团'
        this.getAdvertisement()
    },
    beforeUpdate(){
        
    },
    updated(){
        if(this.kefuimg||this.jujuimg.length||this.ananimg.length){
            this.windowScroll()
        }
    },
    mounted(){
        this.isMobile()
        
    },
    destroyed(){
        
    }
}
</script>
<style scoped>
.my-header{
    z-index: 2000;
    background: #FFFFFF;
    min-width: 1298px;
}
.float-logo-container-right{
    position: absolute;
    top: 440px;
    /* bottom: -228px; */
    left: 50%;
    margin-left: 660px;
    background: #FAFAFA;
    border: 1px solid #E6E6E6;
    box-shadow: 3px 4px 4px 0px rgba(0, 0, 0, 0.04);
    z-index: 99999;
}
.float-logo-container-left{
    position: absolute;
    top: 440px;
    /* bottom: -228px; */
    right: 50%;
    background: #FAFAFA;
    border: 1px solid #E6E6E6;
    box-shadow: 3px 4px 4px 0px rgba(0, 0, 0, 0.04);
    z-index: 99999;
    margin-right: 660px;
}
.img-style{
    display: block;
}
.kefu-img{
    width: 33px;
    height: 33px;
    display: block;
}
</style>
